import '@assets/styles/css/reset.css'
import '@assets/styles/scss/fonts.scss'
import '@assets/styles/scss/initials.scss'
import '@assets/styles/scss/components.scss'
import '@assets/styles/scss/layouts.scss'
import '@assets/styles/scss/utilities.scss'
import '@assets/styles/scss/projects.scss'
import '@assets/styles/scss/libs.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createPersistedState } from "pinia-plugin-persistedstate";

import App from '@src/App.vue'
import router from '@src/router'

import '@plugins/veeValidateSetting.js'
import '@utils/$logger'

import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
dayjs.extend(advancedFormat)
dayjs.locale("ja")

import Vue3Toastify from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

$logger.info('Env settings',
 `APP_ENV -> ${APP_ENV}`
)

const pinia = createPinia()
pinia.use(createPersistedState())
const app = createApp(App)
app
  .use(pinia)
  .use(router)
  .use(Vue3Toastify, {
    autoClose: 15000,
    position: 'top-center',
    transition: 'slide'
  })
app.mount('#app')
